import { render, staticRenderFns } from "./confirm-phrase.vue?vue&type=template&id=6a337804&scoped=true"
import script from "./confirm-phrase.vue?vue&type=script&lang=js"
export * from "./confirm-phrase.vue?vue&type=script&lang=js"
import style0 from "./confirm-phrase.vue?vue&type=style&index=0&id=6a337804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a337804",
  null
  
)

export default component.exports